import "core-js/modules/es.array.fill.js";

/* svg иконка галки в data uri */
var checkedImg = "data:image/svg+xml,%3Csvg width='14' height='11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.715.3a1 1 0 0 1-.015 1.415L5.581 9.664c-.462.452-1.2.452-1.662 0L.3 6.121a1 1 0 1 1 1.4-1.43l3.05 2.987L12.301.285A1 1 0 0 1 13.715.3Z' fill='%23fff'/%3E%3C/svg%3E";
var semiCheckedImg = "data:image/svg+xml,%3Csvg width='12' height='2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1h10' stroke='%23fff' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E";
export var checkboxPortalTokens = {
  colors: {
    base: function base(_ref) {
      var color = _ref.color;
      return color.border.input.base;
    },
    baseHover: function baseHover(_ref2) {
      var color = _ref2.color;
      return color.border.input.hover;
    },
    baseDisabled: function baseDisabled(_ref3) {
      var color = _ref3.color;
      return color.border.input.base;
    },
    checked: function checked(_ref4) {
      var color = _ref4.color;
      return color.importance.primary.base;
    },
    checkedHover: function checkedHover(_ref5) {
      var color = _ref5.color;
      return color.importance.primary.hover;
    },
    checkedDisabled: function checkedDisabled(_ref6) {
      var color = _ref6.color;
      return color.importance.primary.base;
    },
    invalidBase: function invalidBase(_ref7) {
      var color = _ref7.color;
      return color.border.input.invalid.base;
    },
    invalidHover: function invalidHover(_ref8) {
      var color = _ref8.color;
      return color.border.input.invalid.hover;
    },
    focusBase: function focusBase(_ref9) {
      var color = _ref9.color;
      return color.border.focus.base;
    },
    focusHover: function focusHover(_ref10) {
      var color = _ref10.color;
      return color.border.focus.hover;
    },
    focusInvalid: function focusInvalid(_ref11) {
      var color = _ref11.color;
      return color.border.focus.invalid.base;
    },
    focusInvalidHover: function focusInvalidHover(_ref12) {
      var color = _ref12.color;
      return color.border.focus.invalid.hover;
    },
    text: function text(_ref13) {
      var color = _ref13.color;
      return color.text.black.base;
    },
    textDisabled: function textDisabled(_ref14) {
      var color = _ref14.color;
      return color.text.black.base;
    },
    fill: function fill(_ref15) {
      var color = _ref15.color;
      return color.fill.item.base;
    },
    fillDisabled: function fillDisabled(_ref16) {
      var color = _ref16.color;
      return color.fill.item.base;
    },
    opacityOnDisable: 0.5
  },
  wrapperPaddingY: {
    s: 7,
    m: 10,
    l: 12
  },
  iconBox: {
    border: {
      radius: {
        s: 4,
        m: 5,
        l: 6
      },
      width: 2,
      focusBoxShadowAttrs: "0 0 3px 1px"
    },
    sideSize: {
      s: 16,
      m: 20,
      l: 24
    },
    marginTop: {
      s: 1,
      m: 0,
      l: 0
    },
    checkedIcon: {
      imgDataUri: checkedImg,
      imgSizes: {
        s: [10, 9],
        m: [14, 11],
        l: [16, 13]
      }
    },
    indeterminateIcon: {
      imgDataUri: semiCheckedImg,
      imgSizes: {
        s: [10, 2],
        m: [12, 2],
        l: [16, 3]
      }
    }
  },
  label: {
    marginLeft: {
      s: 8,
      m: 8,
      l: 10
    }
  }
};